import { hotToast } from "utils";
import api from "../service";

export const requestAnuncios = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `General/GetAnuncios`,
    null
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};

export const requestFavoritos = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `General/GetFavoritos`,
    null
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};

export const requestRecientes = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `General/GetRecientes`,
    null
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};
